export default $.i18n({
  root: {
    close: 'Masquer ce panneau'
  },
  en: {
    close: 'Hide this panel'
  },
  de: {
    close: 'Blenden Sie dieses Panel aus'
  },
  lb: {
    close: 'Dëse Panel maskéieren'
  }
});
